export default function AmpLightBoxAdCloseButton(props) {
  return (
    <button
      style={{
        position: 'absolute',
        top: 20,
        right: 20,
        border: 'none',
        borderRadius: '50%',
        width: '40px',
        height: '40px',
        fontSize: '24px',
        lineHeight: '1',
        color: 'white',
      }}
      {...props}
    >
      ✕
    </button>
  )
}
